"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberWithSeparators = numberWithSeparators;
exports.numberWithStringSuffix = numberWithStringSuffix;
exports.convertToFloat = convertToFloat;

var _lastIndexOf = _interopRequireDefault(require("lodash/lastIndexOf"));

function numberWithSeparators(number) {
  var lang = navigator.language || navigator.userLanguage;
  return number.toLocaleString(lang, {
    maximumFractionDigits: 2
  });
}

function numberWithStringSuffix(number) {
  var decimalAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var si = [{
    value: 1,
    symbol: ''
  }, {
    value: 1e3,
    symbol: 'k'
  }, {
    value: 1e6,
    symbol: 'M'
  }, {
    value: 1e9,
    symbol: 'G'
  }, {
    value: 1e12,
    symbol: 'T'
  }, {
    value: 1e15,
    symbol: 'P'
  }, {
    value: 1e18,
    symbol: 'E'
  }];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i = 0;

  for (i = si.length - 1; i > 0; i--) {
    if (number >= si[i].value) {
      break;
    }
  }

  return (number / si[i].value).toFixed(decimalAmount).replace(rx, '$1') + si[i].symbol;
}

function convertToFloat(value) {
  var numericRegex = /[^0-9]+/g;
  var stringValue = value ? value.toString() : '0'; // Different languages use the . and , in different parts of the number. So we need to be
  // extra careful to pass the correct number to the currency formatter.

  var decimalSeperatorDot = '.';
  var decimalSeperatorComma = ',';
  var lastIndexDot = (0, _lastIndexOf["default"])(stringValue, decimalSeperatorDot);
  var lastIndexComma = (0, _lastIndexOf["default"])(stringValue, decimalSeperatorComma);
  var lastIndexDecimal = 0;
  lastIndexDecimal = lastIndexComma > lastIndexDot ? lastIndexComma : lastIndexDot;
  var priceNumeral = lastIndexDecimal > -1 ? stringValue.slice(0, lastIndexDecimal) : stringValue;
  var priceDecimal = lastIndexDecimal > -1 ? stringValue.slice(lastIndexDecimal + 1, stringValue.length) : '00';
  var priceNumeralClean = priceNumeral.replace(numericRegex, '');
  var priceDecimalClean = priceDecimal.replace(numericRegex, '');
  return parseFloat("".concat(priceNumeralClean, ".").concat(priceDecimalClean));
}